<template>
    <div>
        <b-row>
            <b-col md="6">
                <CCard>
                    <CCardHeader color="primario" text-color="white">
                        <i class="fas fa-chart-bar"></i> <span class="h5"> Estadísticas</span>
                    </CCardHeader>
                    <CCardBody>
                        <span class="h6 text-muted">ESTADÍSTICAS DEL SISTEMA PARA LA INSPECCIÓN DE BOTIQUIN:
                        </span>
                        <hr>
                        <b-row class="justify-content-center text-center">
                            <b-col cols="12" class=" my-2 icon-custom">
                                <i style="inline-size: auto" class="ico fas fa-check-double fa-3x pb-1"></i>
                                <br>
                                <span class="lg-numero">{{listBotiquin.length}}</span>
                                <br>
                                <span class="text-muted">Inspección Botiquin</span>
                            </b-col>
                        </b-row>
                    </CCardBody>
                </CCard>
            </b-col>
            <b-col md="6">
                <CCard>
                    <CCardHeader color="primario" text-color="white">
                        <i class="fas fa-cog"></i><span class="h5"> Inspección Botiquin</span>
                    </CCardHeader>
                    <CCardBody>
                        <b-row class="justify-content-center text-center">
                            <b-col cols="6" class="my-2">
                                <b-button block variant="custom" @click="modalRegBotiquin = true">
                                    <i style="inline-size: auto" class="fas fa-plus-circle fa-3x pb-1"></i><br><span>Nueva Inspección de Botiquin</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </CCardBody>
                </CCard>
            </b-col>

            <b-col md="12">
                <CCard>
                    <CCardHeader color="primario" text-color="white">
                        <i class="fas fa-list fa-md"></i><span class="h5"> Lista de Inspección Botiquin Registrados </span>
                        <b-button v-if="listBotiquin.length >= 1" class="float-right" variant="success" size="sm" @click="exportDataToExcel">
                        <i class="fas fa-download mr-1"></i>
                        Exportar</b-button>
                    </CCardHeader>
                    <CCardBody>
                        <b-row>
                            <b-col md="3">
                                <b-form-group label="Registros por página" class="text-muted">
                                    <b-form-select size="xl" v-model="porPagina" :options="paginaOpciones"></b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                            </b-col>
                            <b-col md="3">
                                <b-form-group label="Busqueda:" class="text-muted">
                                    <b-input-group size="xl">
                                        <b-input-group-prepend is-text>
                                            <i class="fas fa-search my-0 mx-0"></i>
                                        </b-input-group-prepend>
                                        <b-form-input type="search" v-model="filter" id="filterInput" placeholder="Buscar..."></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col md="12">
                                <b-table bordered hover show-empty mediun responsive outlined :items="listBotiquin" :fields="camposBotiquin" :current-page="paginaActual" :per-page="porPagina" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" empty-text="Aún no hay datos en esta sección." empty-filtered-text="No hay datos que coincidan con tu busqueda.">
                                    <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                                    <template v-slot:cell(nombreGuiaPrincipal)="data">
                                        <template v-if="listUsuarios.find(x => x.idGuia == data.item.idGuia) == null">
                                            {{''}}
                                        </template>
                                        <template v-else>
                                            {{listUsuarios.find(x => x.idGuia == data.item.idGuia).nombre | truncate(50)}}
                                        </template>
                                        <!-- {{listUsuarios.find(x => x.idGuia == data.item.idGuia).nombre | truncate(50)}} -->
                                    </template>
                                    <template v-slot:cell(nombreBotiquin)="data">
                                        {{data.item.nombreBotiquin | truncate(30)}}
                                    </template>
                                    <template v-slot:cell(uso)="data">
                                        <i v-if="data.item.evaluacion == 0" class="fas fa-question-circle"></i>
                                        <i v-if="data.item.evaluacion == 1" class="fas fa-check-circle"></i>
                                        <i v-if="data.item.evaluacion == 2" class="fas fa-times-circle"></i>
                                    </template>
                                    <template v-slot:cell(observacion)="data">
                                        {{data.item.observacion | truncate(30)}}
                                    </template>
                                    <template v-slot:cell(opciones)="param">
                                        <b-button size="sm" v-c-tooltip.hover.click="'Ver detalles'" @click="abrirModalActBotiquin(param)" variant="dark" class=" mr-1 mb-1">
                                            <span class="btn-inner--icon">
                                                <i class="fas fa-search my-0 mx-0"></i>
                                            </span>
                                        </b-button>
                                        <b-button size="sm" class="mr-1 mb-1" v-c-tooltip.hover.click="'Eliminar'" @click="eliminarBotiquin(param)" variant="danger">
                                            <span class="btn-inner--icon">
                                                <i class="fas fa-trash-alt  my-0 mx-0"></i>
                                            </span>
                                        </b-button>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </CCardBody>
                    <CCardFooter>
                        <b-pagination size="sm" v-model="paginaActual" :total-rows="filasTotales" :per-page="porPagina" first-number last-number align="right" class="my-0"></b-pagination>
                    </CCardfooter>
                </CCard>
            </b-col>
        </b-row>

        <CModal :show.sync="modalRegBotiquin" size="xl" color="primario" :closeOnBackdrop="false">
            <template #header>
                <h6 class="modal-title">
                    <i class="fas fa-plus-square fa-md"></i>
                    <span class="h5"> Nuevo Registro de Inspección botiquin</span>
                </h6>
                <CButtonClose @click="modalRegBotiquin = false" class="text-white" />
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(registrarBotiquin)">
                    <b-row>
                        <b-col md="12">
                            <validation-provider name="guia principal" rules="required" v-slot="{errors}">
                                <b-form-group label="Guia Principal:" class="mb-2">
                                    <!-- <v-select :reduce="listDocumentos => listDocumentos.idDocumento" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosGuia.idTipoDocumento , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosGuia.idTipoDocumento" :options="listDocumentos"> -->
                                    <v-select :reduce="listUsuarios => listUsuarios.idGuia" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosRegBotiquin.idGuia , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosRegBotiquin.idGuia" :options="listUsuarios" @search:blur="blurRegBotiquin">
                                        <span slot="no-options" class="text-muted">Busqueda no encontrada</span>
                                    </v-select>
                                    <div class="invalid-feedback">{{ errors[0]}}</div>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="9">
                            <validation-provider name="nombre del botiquin" :rules="{required: true}" v-slot="validationContext">
                                <b-form-group label="Nombre del Botiquin:" class="mb-2">
                                    <b-form-input  :state="getValidationState(validationContext)" placeholder="Ingrese el Nombre del Botiquin" v-model.trim="datosRegBotiquin.nombreBotiquin"></b-form-input>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="3">
                            <validation-provider name="uso" :rules="{required: false}" v-slot="validationContext">
                                <b-form-group label="Uso:" class="mb-2">
                                    <b-form-radio-group v-model.trim="datosRegBotiquin.evaluacion" plain :options="comboSiNo"></b-form-radio-group>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="12">
                            <validation-provider name="observacion" :rules="{required: false}" v-slot="validationContext">
                                <b-form-group label="Observación (Opcional):" class="mb-2">
                                    <b-form-textarea v-model.trim="datosRegBotiquin.observacion" :state="getValidationState(validationContext)" placeholder="Ingrese la Observación" rows="3" max-rows="6"></b-form-textarea>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="12" class="text-right my-2">
                            <b-button :disabled="disabled" variant="success" class=" mr-2" type="submit">
                                Guardar
                            </b-button>
                            <b-button variant="danger" @click="modalRegBotiquin = false">
                                Cancelar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </CModal>

        <CModal :show.sync="modalActBotiquin" size="xl" color="primario" :closeOnBackdrop="false">
            <template #header>
                <h6 class="modal-title">
                    <i class="fas fa-plus-square fa-md"></i>
                    <span class="h5"> Actualizar Inspección botiquin</span>
                </h6>
                <CButtonClose @click="modalActBotiquin = false" class="text-white" />
            </template>
            <validation-observer ref="observer1" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(modificarBotiquin)">
                    <b-row>
                        <b-col md="12">
                            <validation-provider name="guia principal" rules="required" v-slot="{errors}">
                                <b-form-group label="Guia Principal:" class="mb-2">
                                    <!-- <v-select :reduce="listDocumentos => listDocumentos.idDocumento" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosGuia.idTipoDocumento , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosGuia.idTipoDocumento" :options="listDocumentos"> -->
                                    <v-select :reduce="listUsuarios => listUsuarios.idGuia" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosActBotiquin.idGuia , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosActBotiquin.idGuia" :options="listUsuarios" @search:blur="blurActBotiquin">
                                        <span slot="no-options" class="text-muted">Busqueda no encontrada</span>
                                    </v-select>
                                    <div class="invalid-feedback">{{ errors[0]}}</div>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="9">
                            <validation-provider name="nombre del botiquin" :rules="{required: true}" v-slot="validationContext">
                                <b-form-group label="Nombre del Botiquin:" class="mb-2">
                                    <b-form-input  :state="getValidationState(validationContext)" placeholder="Ingrese el Nombre del Botiquin" v-model.trim="datosActBotiquin.nombreBotiquin"></b-form-input>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="3">
                            <validation-provider name="uso" :rules="{required: false}" v-slot="validationContext">
                                <b-form-group label="Uso:" class="mb-2">
                                    <b-form-radio-group v-model.trim="datosActBotiquin.evaluacion" plain :options="comboSiNo"></b-form-radio-group>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="12">
                            <validation-provider name="observacion" :rules="{required: false}" v-slot="validationContext">
                                <b-form-group label="Observación (Opcional):" class="mb-2">
                                    <b-form-textarea v-model.trim="datosActBotiquin.observacion" :state="getValidationState(validationContext)" placeholder="Ingrese la Observación" rows="3" max-rows="6"></b-form-textarea>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="12" class="text-right my-2">
                            <b-button :disabled="disabled" variant="success" class=" mr-2" type="submit">
                                Actualizar
                            </b-button>
                            <b-button variant="danger" @click="modalActBotiquin = false">
                                Cancelar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
            
        </CModal>
    </div>
</template>

<script>
import firebase from 'firebase';
const dbUsuario = firebase.firestore().collection('users');
const dbBotiquin = firebase.firestore().collection('inspeccionBotiquin');
import XLSX from 'sheetjs-style-v2';

export default {
    data(){
        return {
            listBotiquin: [],
            listUsuarios: [],
            disabled: false,

            filasTotales: 1,
            paginaActual: 1,
            porPagina: 10,
            paginaOpciones: [10, 25, 50, 100, {
                value: 9999999,
                text: "Mostrar todos"
            }],
            filter: null,
            filterOn: [],

            camposBotiquin: [
                {
                    key: "index",
                    label: "N°",
                    class: "text-center",
                },
                {
                    key: "nombreGuiaPrincipal",
                    label: "Guia Principal",
                    class: "text-center",
                },
                {
                    key: "nombreBotiquin",
                    label: "Nombre Botiquin",
                    class: "text-center",
                },
                {
                    key: "uso",
                    label: "Uso",
                    class: "text-center",
                },
                {
                    key: "observacion",
                    label: "Observación",
                    class: "text-center",
                },
                {
                    key: "opciones",
                    label: "",
                    class: "text-center",
                },
            ],

            datosRegBotiquin: {
                idGuia: '',
                nombreBotiquin: '',
                evaluacion: 0,
                observacion: '',
            },

            datosActBotiquin: {
                id: '',
                idGuia: '',
                nombreBotiquin: '',
                evaluacion: 0,
                observacion: '',
            },

            comboSiNo: [
                {
                    value: 1,
                    text: 'Si',
                },
                {
                    value: 2    ,
                    text: 'No',
                },
            ],
            modalRegBotiquin: false,
            modalActBotiquin: false,
        }
    },
    methods: {
        exportDataToExcel() {
            let now = moment().format('YYYYMMDDHHmm');

            const valUpper = text => {
                if (text != null && text !== undefined) {
                    return text.toString().toUpperCase();
                }
                return '';
            };

            const valDate = date => {
                if (date && date !== undefined) {
                    return moment(date).format('DD-MM-YYYY')
                }
                return '';
            };

            let dataExcel = this.listBotiquin.map(data => {
                return {
                    A: valUpper(this.listUsuarios && this.listUsuarios !== undefined ?
                        this.listUsuarios.filter(x => x.idGuia == data.idGuia).length > 0 ?
                        this.listUsuarios.filter(x => x.idGuia == data.idGuia)[0].nombre : '' : ''),
                    B: valUpper(data['nombreBotiquin']),
                    C: data['evaluacion'] == 1 ? 'SI' : data['evaluacion'] == 2 ? 'NO' : '',
                    D: valUpper(data['observacion']),
                };
            });

            let dataWS = XLSX.utils.json_to_sheet(dataExcel, {
                origin: 'A4',
            });

            let dataWSMerges = [{
                s: {
                    r: 1,
                    c: 1,
                },
                e: {
                    r: 1,
                    c: 3,
                },
            }];

            dataWS['!merges'] = dataWSMerges;

            let dataWSCols = [
                {
                    wch: 30, //A
                },
                {
                    wch: 30, //B
                },
                {
                    wch: 10, //C
                },
                {
                    wch: 50, //D
                },
            ];

            dataWS['!cols'] = dataWSCols;

            for(let i of [
                {
                    f: 'B2',
                    v: 'INSPECCIÓN DE BOTIQUIN',
                },
                {
                    f: 'C2',
                },
                {
                    f: 'D2',
                },
                {
                    f: 'A4',
                    v: 'NOMBRE DE GUÍA',
                },
                {
                    f: 'B4',
                    v: 'NOMBRE DEL BOTIQUIN',
                },
                {
                    f: 'C4',
                    v: 'USO',
                },
                {
                    f: 'D4',
                    v: 'OBSERVACIÓN',
                },
            ]){
                XLSX.utils.sheet_add_aoa(dataWS, [
                    [i.v || '']
                ], {
                    origin: i.f,
                });

                dataWS[i.f].s = {
                    numFmt: i.w || 'general',
                    fill: {
                        fgColor: {
                            rgb: i.b ? 'FFFFFF' : 'F2F2F2',
                        },
                    },
                    font: {
                        name: 'arial',
                        sz: 8,
                        bold: i.b ? false : true,
                        color: {
                            rgb: i.b ? '000000' : '1F497D',
                        },
                    },
                    border: {
                        top: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                        bottom: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                        right: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                        left: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                    },
                    alignment: {
                        horizontal: 'center',
                        vertical: 'center',
                        wrapText: 1,
                    },
                };
            }

            for (let k in dataExcel) {
                for (let i of Object.keys(dataExcel[0])) {
                    dataWS[`${i}${(parseInt(k) + 5).toString()}`].s = {
                        numFmt: '@',
                        fill: {
                            fgColor: {
                                rgb: 'FFFFFF',
                            },
                        },
                        font: {
                            name: 'arial',
                            sz: 8,
                            color: {
                                rgb: '000000',
                            },
                        },
                        border: {
                            top: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                            bottom: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                            right: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                            left: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                        },
                        alignment: {
                            horizontal: 'center',
                            vertical: 'center',
                        },
                    };
                }
            }

            let wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, dataWS, 'INSPECCIÓN DE BOTIQUIN');
            XLSX.writeFile(wb, `INSPECCIÓN DE BOTIQUIN ${now}.xlsx`);
        },
        onFiltered(itemsFiltrados) {
            this.filasTotales = itemsFiltrados.length
            this.paginaActual = 1
        },
        getValidationState({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        blurRegBotiquin() {
            this.computedForms.refs['guia principal'].validate();
        },
        blurActBotiquin() {
            this.computedFormActualizar.refs['guia principal'].validate();
        },
        listarUsuarios() {
            let me = this;

            dbUsuario
            .where("estado" , "==" , 2)
            .where("idCliente", "==", String(me.$store.state.user.idCliente))
            .where("rol","==","guia")
            .onSnapshot((querySnapshot) => {
                me.listUsuarios = [];
                querySnapshot.forEach((doc) => {
                    me.listUsuarios.push({
                        idGuia: doc.id,
                        nombre: doc.data().nombre + ' ' + doc.data().apellidoPaterno + ' ' + doc.data().apellidoMaterno,
                    });
                });
            });
        },
        registrarBotiquin() {
            let me = this;

            me.disabled = true;
            dbBotiquin.add({
                idGuia: me.datosRegBotiquin.idGuia.trim(),
                nombreBotiquin: me.datosRegBotiquin.nombreBotiquin.trim(),
                evaluacion: me.datosRegBotiquin.evaluacion,
                observacion: me.datosRegBotiquin.observacion.trim(),
                estado: 2,
                fechaCreacion: firebase.firestore.Timestamp.fromDate(new Date()),
                fechaModificacion: '',
                fechaEliminar: '',
                idCliente: me.$store.state.user.idCliente.trim(),
            }).then((doc) =>{
                me.swat('success', 'Registrado satisfactoriamente')
                me.modalRegBotiquin = false;
                me.disabled = false;
            }).catch((error) => {
                me.disabled = false;
                me.swat('error', 'Algo salió mal!');
            });
        },
        listarBotiquin() {
            let me = this;
            
            dbBotiquin
            .where("estado","==", 2)
            .where("idCliente", "==", String(me.$store.state.user.idCliente))
            .onSnapshot((querySnapshot) => {
                me.listBotiquin = [];
                querySnapshot.forEach((doc)=> {
                    me.listBotiquin.push({
                        id: doc.id,
                        idGuia: doc.data().idGuia,
                        nombreBotiquin: doc.data().nombreBotiquin,
                        evaluacion: doc.data().evaluacion,
                        observacion: doc.data().observacion,
                        fechaCreacion: doc.data().fechaCreacion,
                    });
                });

                me.listBotiquin.sort((a, b) => (a.fechaCreacion > b.fechaCreacion) ? -1 : ((b.fechaCreacion > a.fechaCreacion) ? 1 : 0));
            });
        },
        eliminarBotiquin(param) {
            let me = this;

            me.$swal.fire({
                title: '¿Estas seguro de eliminar el Botiquin?',
                text: "¡No podrás revertir esto!",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
            }).then((result) => {
                if (result.isConfirmed) {
                    dbBotiquin.doc(param.item.id).update({
                        estado: 1,
                        fechaEliminar: firebase.firestore.Timestamp.fromDate(new Date()),
                    })
                    .then(() => {
                        me.swat('success', 'Eliminado satisfactoriamente')
                        me.disabled = false;
                    })
                    .catch((error) => {
                        me.disabled = false;
                        me.swat('error', 'Algo salió mal!')
                    });
                }
            });
        },
        abrirModalActBotiquin(param) {
            let me = this;

            me.datosActBotiquin.id = param.item.id;
            me.datosActBotiquin.idGuia = param.item.idGuia;
            me.datosActBotiquin.nombreBotiquin = param.item.nombreBotiquin.trim();
            me.datosActBotiquin.evaluacion = param.item.evaluacion;
            me.datosActBotiquin.observacion = param.item.observacion.trim();

            me.modalActBotiquin = true;
        },
        modificarBotiquin() {
            let me = this;

            me.disabled = true;

            dbBotiquin.doc(me.datosActBotiquin.id).update({
                idGuia: me.datosActBotiquin.idGuia.trim(),
                nombreBotiquin: me.datosActBotiquin.nombreBotiquin.trim(),
                evaluacion: me.datosActBotiquin.evaluacion,
                observacion: me.datosActBotiquin.observacion.trim(),
                fechaModificacion: firebase.firestore.Timestamp.fromDate(new Date()),
            }).then((doc)=> {
                me.swat('success', 'Modificado satisfactoriamente');
                me.modalActBotiquin = false;
                me.disabled = false;
            }).catch((error) => {
                me.disabled = false;
                me.swat('error', 'Algo salió mal!');
            });
        },
        swat(icon, title) {
            this.$swal.mixin({
                toast: true,
                showConfirmButton: false,
                position: 'bottom-right',
                timer: 3500,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            }).fire({
                icon: icon,
                title: title
            });
        },
        resetModalRegBotiquin() {
            this.$nextTick(() => {
                this.$refs.observer.reset();
            });

            this.datosRegBotiquin.idGuia = '';
            this.datosRegBotiquin.nombreBotiquin = '';
            this.datosRegBotiquin.evaluacion = 0;
            this.datosRegBotiquin.observacion = '';
        },
        resetModalActBotiquin() {
            this.$nextTick(() => {
                this.$refs.observer1.reset();
            });

            this.datosActBotiquin.id = '';
            this.datosActBotiquin.idGuia = '';
            this.datosActBotiquin.nombreBotiquin = '';
            this.datosActBotiquin.evaluacion = 0;
            this.datosActBotiquin.observacion = '';
        },
    },
    computed: {
        computedForms() {
            return this.$refs.observer;
        },
        computedFormActualizar() {
            return this.$refs.observer1;
        },
    },
    watch: {
        modalRegBotiquin: function (val) {
            if (val == false) {
                this.resetModalRegBotiquin();
            }
        },
        modalActBotiquin: function (val) {
            if (val == false) {
                this.resetModalActBotiquin();
            }
        },
    },
    mounted(){
        if (this.$store.state.user) {
            this.listarUsuarios();
            this.listarBotiquin();
        }
    },
}
</script>